import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Handshake, CheckCircle, Shield, Star, Globe, Users } from 'lucide-react';

export default function ForPartnersPage() {
  return (
    <div className="min-h-screen py-24 md:py-32 bg-background" data-testid="for-partners-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-medium tracking-wider uppercase text-secondary mb-3 block">Pour les partenaires</span>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Rejoignez le réseau M-CareLink
          </h1>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Hébergeurs, transporteurs PMR, auxiliaires de vie, prestataires d'activités : contribuez à rendre les vacances accessibles à tous.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {[
            { icon: Users, title: "Clientèle qualifiée", desc: "Accédez à une clientèle ciblée et qualifiée de dyades aidant-aidé, avec des besoins clairement identifiés." },
            { icon: Shield, title: "Label qualité", desc: "Bénéficiez d'une mise en avant de votre engagement en matière d'accessibilité et de qualité de service." },
            { icon: Globe, title: "Visibilité", desc: "Intégrez un réseau national de partenaires engagés dans l'inclusion et l'accessibilité." },
            { icon: Star, title: "Accompagnement", desc: "Notre équipe vous accompagne dans l'optimisation de votre offre d'accessibilité." }
          ].map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-white rounded-2xl p-8 border border-border/30 shadow-sm hover:shadow-md transition-all">
              <Icon className="w-8 h-8 text-secondary mb-4" />
              <h3 className="font-heading text-xl font-semibold mb-2">{title}</h3>
              <p className="text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 border border-border/30 shadow-sm mb-12">
          <h2 className="font-heading text-2xl font-semibold text-foreground mb-6">Catégories de partenaires</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {[
              "Hébergements accessibles (hôtels, résidences, gîtes)",
              "Transport adapté PMR (véhicules, transferts)",
              "Assistance humaine (auxiliaires de vie, accompagnants)",
              "Matériel médical et de mobilité",
              "Activités de loisirs adaptées et inclusives",
              "Prestataires de restauration adaptée"
            ].map((text, i) => (
              <div key={i} className="flex items-start gap-3 py-2">
                <CheckCircle className="w-5 h-5 text-secondary flex-shrink-0 mt-0.5" />
                <p className="text-foreground">{text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <Link to="/devenir-partenaire">
            <Button className="rounded-full bg-secondary text-secondary-foreground px-8 py-6 text-lg font-semibold hover:bg-secondary/90 shadow-lg hover:scale-105 transition-all" data-testid="partners-page-cta">
              Devenir partenaire <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
